export default __webpack_public_path__ + "static/media/icon-question-mark.297e0ea7.svg";